import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Theme from "../../../styles/Theme/Theme";
import logger from "../../../server/logger";
import Button from "./Button";

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const StyledSidebar = styled.div`
    width: 235px;
    min-width: 235px;
    background-color:${Theme.color['neutral-2']} ;
    position: relative;
    display: ${(props) => props.display ? null : "none"};
    z-index: 1;
    font-family: ${Theme.typography.fontFamily};
    font-size: ${Theme.typography.fontSize.text_md_desktop};

    ul{
        height: auto;
        padding: 0;
        margin: 0;
        
        li{
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            padding: ${Theme.spacing.s02} 0;
            margin: 0;
            color: ${Theme.color["coolgray-6"]};

            p {
                padding: 0 ${Theme.spacing.s08};
            }

            .active{
                color: ${Theme.color["black-1"]};
                font-weight: ${Theme.typography.weight};
                border-left: 4px solid ${Theme.color["green-deloitte"]};
            }
            
            :hover{
                color: ${Theme.color["black-1"]};
            }
        
    }
}
`;

const Footer = styled.div`
    color: #C4D600;
    text-align: center;
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    > p{
        margin-right: 10px;
    }
`;
//#endregion

export const Sidebar = ({ sideBarMenu, activeTab, setCurrentTab, disableSideBar }) => {
    const { t } = useTranslation();

    function handlePath(path) {
        try {
            window.location.hash = path;
            //handlePagePathChange(path)
        } catch (error) {
            console.error('(SideBar page) Error in function handlingPath:', error);
            //reportError(error); // Send error report to backend
            logger.error('(SideBar page) Error in function handlingPath:', error)
        }
    }

    return (
        <StyledSidebar display={sideBarMenu}>
            <ul>
                {sideBarMenu ? sideBarMenu.map((val, key) => {
                    return (
                        <li key={key}>
                            <div className={activeTab === val.label ? "active" : ""}>
                                <Button onClick={() => { setCurrentTab(val.label); handlePath(val.path); }}
                                    $backgroundColor='none' color='black' size='s' disabled={disableSideBar} $disabledColor='lightgray'
                                    $focusBoxShadow='none' $hoverBackgroundColor='none' $disabledBackgroundColor='none'>{t(val.name)}</Button>
                            </div>
                            {/* <ul display={activeTab === val.label ? null : "none"}>
                                {val?.submenus ? val?.submenus.map((x, index) => {
                                    return (
                                        <li key={index} className={activeTab === index ? "active" : ""}>{t(x)}</li>
                                    )
                                }) : null}
                            </ul> */}
                        </li>
                    )
                }) : null}
            </ul>
        </StyledSidebar>
    )
}